<template>
  <div
    :class="$style.signatureWrapper"
    v-html="htmlOutput"
  />
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */
import offices from 'src/data/offices';

export default {
  name: 'Signature',
  props: {
    division: {
      type: Object,
      required: true,
    },
    person: {
      type: Object,
      required: true,
    },
    hasPhone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      offices,
      office: null,
    };
  },
  computed: {
    imageUrl() {
      return `${location.href.replace(/#.*/, '')}images/emailLogos/${
        this.division.emailLogo
      }`;
    },
    socialIconUrl() {
      return `${location.href.replace(/#.*/, '')}images/social/`;
    },
    hasFacebook() {
      return this.person.socials.includes('fb');
    },
    hasInstagram() {
      return this.person.socials.includes('ig');
    },
    hasLinkedIn() {
      return this.person.socials.includes('li');
    },
    hasSocial() {
      return this.hasFacebook || this.hasLinkedIn || this.hasInstagram;
    },
    hasMeetingLink() {
      if (this.person.meetingLink) {
        return true;
      }
      return false;
    },
    htmlOutput() {
      // Name and Title Block
      let htmlTemplate = `<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600">
        <tr><td><![endif]--><div style="font-family:Arial,sans-serif;font-size:11px;line-height:12px;text-align:left;color:#272e3c;display: block;width: 600px;"><span style="font-size:15px;font-weight:bold;line-height:1;color:#0076ff;">
        ${this.person.firstName} ${this.person.lastName}</span> ${this.person.pronoun}
      <br/><span style="font-size:12px;font-weight:bold;line-height:1;display: block;">${this.person.title}</span><!--[if mso | IE]><br/><![endif]-->`;

      // Office Address Block
      if (this.office) {
        htmlTemplate += `<br/>${this.headquarters}${this.office.street}<br/>${this.office.city}, ${this.office.state} ${this.office.zip}<br/>`;
      }

      // Phone Block
      htmlTemplate += `${this.phoneList}<br/>`;

      // Email Block
      if (this.person.email) {
        htmlTemplate += `<span style="display:block;"><a href="mailto:${this.person.email}" style="color:#272e3c;">${this.person.email}</a></span><!--[if mso | IE]><br/><![endif]-->`;
      }

      // Meeting Link Block
      if (this.person.meetingLink) {
        htmlTemplate += `<span style="font-weight:bold;display:block;">
                                  <a href="${this.person.meetingLink}"
                                    style="color:#272e3c;">Book a meeting with ${this.person.firstName}</a>
                                </span><!--[if mso | IE]><br/><![endif]-->`;
      }

      // Logo Image Block
      htmlTemplate += `<br/><img height="23" src="${this.imageUrl}" style="border:0;display:block;outline:none;text-decoration:none;height:23px;width:124px;font-size:13px;" width="124"/>
                              <!--[if mso | IE]><br/><![endif]--><br/><span style="font-size:12px;font-weight:bold;">
                                <a href="https://www.go2partners.com" style="color:#272e3c; text-decoration:none;">go2partners.com</a>
                              </span>`;
      if (this.hasSocial) {
        // Social Media Block
        htmlTemplate += `<br/><br/><!--[if mso | IE]>
          <table align="left" border="0" cellpadding="0" cellspacing="0" class="" role="presentation">
            <tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;margin-right:8px; margin-left:0"><![endif]-->${this.showFacebookIcon2}<!--[if mso | IE]></td><![endif]-->
            <!--[if mso | IE]><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;margin-right:8px; margin-left:0"><![endif]-->${this.showLinkedinIcon2}<!--[if mso | IE]></td><![endif]-->
            <!--[if mso | IE]><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;margin-left:0"><![endif]-->${this.showInstagramIcon2}<!--[if mso | IE]></td></tr></table><![endif]-->`;
      }

      // Disclaimer Text Block
      htmlTemplate += `<br/><br/><!--[if mso | IE]><br/><br/></td></tr><tr><td style="font-size:10px;line-height:10px;text-align:justify;"><![endif]-->
                          <span style="font-size:10px;line-height:10px;text-align:justify;display:block;">${this.division.disclaimer}</span>
                          <br/><!--[if mso | IE]></td></tr><tr><td><![endif]-->`;

      htmlTemplate += `</div><!--[if mso | IE]></td></tr></table><![endif]-->`;

      return htmlTemplate;
    },

    phoneList() {
      let list = '';

      for (var phone of this.person.phones) {
        if (phone.phoneNumber != '' || phone.phoneType != '') {
          list += `<span>${this.formatType(
            phone.phoneType,
          )} </span><span>${this.formatNumber(phone.phoneNumber)}<br></span>`;
        }
      }

      return list;
    },
    headquarters() {
      if (this.office.headquarters) {
        return `<span>GO2 Headquarters<br/></span>`;
      }
      return '';
    },
    showFacebookIcon() {
      if (this.hasFacebook) {
        return `<table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
            <tbody>
              <tr>
                <td style="padding:4px;vertical-align:middle;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3b5998;border-radius:3px;width:18px;">
                    <tbody>
                      <tr>
                        <td style="font-size:0;height:18px;vertical-align:middle;width:18px;">
                          <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.facebook.com/go2partners"" target="_blank">
                          <img height="18" src="https://www.mailjet.com/images/theme/v1/icons/ico-social/facebook.png" style="border-radius:3px;display:block;" width="18"/> </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>`;
      }
      return '';
    },
    showLinkedinIcon() {
      if (this.hasLinkedIn) {
        return `<table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
            <tbody>
              <tr>
                <td style="padding:4px;vertical-align:middle;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0077b5;border-radius:3px;width:18px;">
                    <tbody>
                      <tr>
                        <td style="font-size:0;height:18px;vertical-align:middle;width:18px;">
                          <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://www.linkedin.com/company/go2partners&title=&summary=&source=" target="_blank">
                          <img height="18" src="https://www.mailjet.com/images/theme/v1/icons/ico-social/linkedin.png" style="border-radius:3px;display:block;" width="18"/> </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>`;
      }
      return '';
    },
    showInstagramIcon() {
      if (this.hasInstagram) {
        return `<table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
          <tbody>
            <tr>
              <td style="padding:4px;vertical-align:middle;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3f729b;border-radius:3px;width:18px;">
                  <tbody>
                    <tr>
                      <td style="font-size:0;height:18px;vertical-align:middle;width:18px;">
                        <a href="https://www.instagram.com/go2partners/" target="_blank">
                        <img height="18" src="https://www.mailjet.com/images/theme/v1/icons/ico-social/instagram.png" style="border-radius:3px;display:block;" width="18"/> </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>`;
      }
      return '';
    },
    showFacebookIcon2() {
      if (this.hasFacebook) {
        return `<a href="https://www.facebook.com/go2partners" target="_blank" style="display:inline-block;background:#3b5998;border-radius:3px;width:18px;">
                          <img height="18" src="${this.socialIconUrl}facebook.png" style="border-radius:3px;display:block;" width="18"/> </a>`;
      }
      return '';
    },
    showLinkedinIcon2() {
      if (this.hasLinkedIn) {
        return `&nbsp;<a href="https://www.linkedin.com/company/go2partners" target="_blank" style="display: inline-block;background:#0077b5;border-radius:3px;width:18px;">
                          <img height="18" src="${this.socialIconUrl}linkedin.png" style="border-radius:3px;display:block;" width="18"/> </a>`;
      }
      return '';
    },
    showInstagramIcon2() {
      if (this.hasInstagram) {
        return `&nbsp;<a href="https://www.instagram.com/go2partners/" target="_blank" style="display:inline-block;background:#eb3578;border-radius:3px;width:18px;">
                        <img height="18" src="${this.socialIconUrl}instagram.png" style="border-radius:3px;display:block;" width="18"/> </a>`;
      }
      return '';
    },
  },
  watch: {
    'person.office'() {
      this.office = offices.find(
        (office) => office.name === this.person.office,
      );
    },
  },
  methods: {
    formatNumber(s) {
      let s2 = ('' + s).replace(/\D/g, '');
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return !m ? s2 : m[1] + ' ' + m[2] + ' ' + m[3];
    },
    formatType(value) {
      return value.substring(0, 1);
    },
  },
};
</script>
<style lang="scss" module>
@import "src/brand/brandColors.variables";

.fontStack {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

.signatureWrapper {
  max-width: 600px;
}
</style>
